export enum PAYMENT_METHODS_TYPES {
  CREDIT_CARD = "CREDIT_CARD",
  ONE_BILL = "ONE_BILL",
  IBFT = "IBFT",
  BANK_TRANSFER = "BANK_TRANSFER",
}
